

































































































































































































































































































































































































import CardPanel from '@/components/common/CardPanel.vue'
import { Component, Ref } from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import SimpleUploader from '@/components/common/SimpleUploader.vue'
import { ElForm } from 'element-ui/types/form'
import SelectPanel from '@/components/common/SelectPanel.vue'
import { createTask, getAlgParamList } from '@/request/apis/ConvertFastqRequest'
import { getExample } from '@/request/apis/common'
import { getSocket } from '@/socket.io'
import { PushDetail } from '@/types/Message'
import { lowerFirst } from 'lodash'


@Component({
  components: {
    CardPanel,
    SimpleUploader,
    SelectPanel
  }
})
export default class ConvertFastqForm extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm

  private speciesList: string[] = ['human']
  private speciesOptions: string[] = []
  private whiteListOptions: string[] = ['3M-february-2018.txt']
  private fastqOptions: string[] = ['pbmc_0.5m_v3_1.fastq']
  private speciesExample: string = ''
  private whitelistExample: string = ''
  private loadingProcessButton: boolean = false
  private type: string = 'ConvertFastq'
  private finishListener!: Function
  private jobId: string = ''

  private form: any = {
    type: 'sparkSTARSolo',
    algSc: {
      species: 'human',
      fastq1: '',
      fastq2: '',
      cellNum: 100
    },
    algSpark: {
      species: '',
      fastq1: '',
      fastq2: '',
      whiteList: '',
      version: 'V3',
      speciesInputType: 'choose',
      whiteListInputType: 'choose'
    }
  }

  get id () {
    return this.$route.params.id
  }

  mounted () {
    // this.getAlgList()
    // this.getExample()
    this.addSocketListener()
  }

  destroyed () {
    const socket = getSocket()
    socket.off('job_finish', this.finishListener)
  }

  // private async getAlgList () {
  //   const res = await getAlgParamList(null).start()
  //   this.whiteListOptions = res.white_list
  //   this.speciesOptions = res.species_list
  // }
  //
  // private async getExample () {
  //   const result = await getExample(null).start()
  //   this.speciesExample = result.species_example
  //   this.whitelistExample = result.whitelist_example
  // }

  // 切换tab时清除验证
  private clearValidate () {
    this.submitForm.clearValidate()
  }

  private addSocketListener () {
    const socket = getSocket()
    if (!socket) return
    this.finishListener = (msgDetail: PushDetail) => {
      if (this.jobId === msgDetail.id) {
        this.loadingProcessButton = false
      }
    }
    socket.on('job_finish', this.finishListener)
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {}
          if (this.form.type === 'sparkSTARSolo') {
            params = {
              species: this.form.algSpark.species,
              fastq1: this.form.algSpark.fastq1,
              fastq2: this.form.algSpark.fastq2,
              version: this.form.algSpark.version,
              whitelist: this.form.algSpark.whiteList
            }
          } else {
            params = {
              species: this.form.algSc.species,
              fastq1: this.form.algSc.fastq1,
              fastq2: this.form.algSc.fastq2,
              cell_num: this.form.algSc.cellNum
            }
          }
          params['type'] = this.form.type
          const res = await createTask(null, params).start()
          this.jobId = res.job_id
        } catch (e) {
          console.warn(e)
        }
      } else {
        return false
      }
    })
  }

  private get rules () {
    if (this.form.type === 'scSpark') {
      return {
        'algSc.species': [
          { required: true, message: 'species is required', trigger: 'change' }
        ],
        'algSc.fastq1': [
          { required: true, message: 'fastq1 is required', trigger: 'change' }
        ],
        'algSc.fastq2': [
          { required: true, message: 'fastq2 is required', trigger: 'change' }
        ],
        'algSc.cellNum': [
          { required: true, message: 'cellNum is required', trigger: 'change' }
        ]
      }
    } else {
      return {
        'algSpark.species': [
          { required: true, message: 'species is required', trigger: 'change' }
        ],
        'algSpark.fastq1': [
          { required: true, message: 'fastq1 is required', trigger: 'change' }
        ],
        'algSpark.fastq2': [
          { required: true, message: 'fastq2 is required', trigger: 'change' }
        ],
        'algSpark.whiteList': [
          { required: true, message: 'whiteList is required', trigger: 'blur' }
        ]
      }
    }
  }
}
